module.exports = __webpack_public_path__ + "img/BS.b60d4fc2.svg";